import { USER_ROLE, canInviteAny } from './userRoles';

// Which Access manager actions the signed-in user may take — each mirrors an iscc-backend guard.

const EDITOR_ROLES = Object.freeze([USER_ROLE.admin, USER_ROLE.superAdmin]);

const isSelf = (me, row) => me?.id != null && Number(me.id) === Number(row.id);

/** `me` is the session user view model; every predicate takes a list row. */
export const buildUserPermissions = (me) => {
  const role = me?.role;
  const isSuperAdmin = role === USER_ROLE.superAdmin;
  return {
    // POST /auth/invite-user — canInviteRole must allow at least one role.
    canInvite: canInviteAny(role),
    // PUT /access-manager/users/:id — ADMIN / SUPER_ADMIN, never your own user.
    canEdit: (row) => EDITOR_ROLES.includes(role) && !isSelf(me, row),
    // DELETE /auth/remove-user/:id — SUPER_ADMIN only.
    canRemove: (row) => isSuperAdmin && !row.isPending && !isSelf(me, row),
    // GET /auth/invitation-reminder/:id — SUPER_ADMIN, pending invitees only.
    canRemind: (row) => isSuperAdmin && row.isPending,
    canRevoke: (row) => isSuperAdmin && row.isPending,
  };
};
